import $ from "jquery";
import Translate from "../js/translates";

export default {
    init() {
        $('.language-selector__item').click(function () {
            if ($(this).hasClass('language-selector__item--selected')) {
                let parent = $(this).parent();

                if (parent.hasClass('language-selector--open')) {
                    parent.removeClass('language-selector--open');
                } else {
                    parent.addClass('language-selector--open');
                }
                return;
            }

            $(this).prependTo('.language-selector');
            $('.language-selector__item').removeClass('language-selector__item--selected');
            $('.language-selector').removeClass('language-selector--open');
            $(this).addClass('language-selector__item--selected');

            Translate.translateKuwait();
        });
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        $('a.nx-section-transform__link').on('click', (function (e) {
            e.preventDefault();
            let first_input = $("#for_make_active");
            $('html, body').animate({ scrollTop: $(first_input).offset().top-200 }, 500);
            first_input.focus();
        }));
        $('a.nx-section-request__link').on('click', (function (e) {
            e.preventDefault();
            let first_input = $("#for_make_active");
            $('html, body').animate({ scrollTop: $(first_input).offset().top-200 }, "slow");
            first_input.focus();
        }));
    },
};
